(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["expandable-accordion-list"] && !Shopify.designMode) return;
  try {
    
(function () {
  function toggleItem(trigger) {
    var content = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!content) return;

    var isOpen = trigger.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
      content.style.maxHeight = content.scrollHeight + 'px';
      requestAnimationFrame(function () {
        content.style.maxHeight = '0px';
        content.style.opacity = '0';
      });
      trigger.setAttribute('aria-expanded', 'false');
      content.setAttribute('aria-hidden', 'true');
    } else {
      content.style.maxHeight = content.scrollHeight + 'px';
      content.style.opacity = '1';
      trigger.setAttribute('aria-expanded', 'true');
      content.setAttribute('aria-hidden', 'false');
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.eal-item__trigger');
    if (!trigger) return;
    toggleItem(trigger);
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('.eal-item__trigger[aria-expanded="true"]').forEach(function (trigger) {
      var content = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!content) return;
      content.style.maxHeight = 'none';
      var h = content.scrollHeight;
      content.style.maxHeight = h + 'px';
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["expandable-content-blocks"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('.ecb-toggle');
    if (!toggle) return;

    var full = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!full) return;

    var isOpen = toggle.getAttribute('aria-expanded') === 'true';
    var label = toggle.querySelector('.ecb-toggle__text');

    if (isOpen) {
      full.style.maxHeight = full.scrollHeight + 'px';
      requestAnimationFrame(function () {
        full.style.maxHeight = '0px';
        full.style.opacity = '0';
      });
      toggle.setAttribute('aria-expanded', 'false');
      full.setAttribute('aria-hidden', 'true');
      if (label) label.textContent = toggle.getAttribute('data-read-more');
    } else {
      full.style.maxHeight = full.scrollHeight + 'px';
      full.style.opacity = '1';
      toggle.setAttribute('aria-expanded', 'true');
      full.setAttribute('aria-hidden', 'false');
      if (label) label.textContent = toggle.getAttribute('data-show-less');
    }
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('.ecb-toggle[aria-expanded="true"]').forEach(function (toggle) {
      var full = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!full) return;
      full.style.maxHeight = 'none';
      var h = full.scrollHeight;
      full.style.maxHeight = h + 'px';
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
